import { useEffect } from 'react'

const ICAS_SCRIPT_URL = 'https://api.lyrawellbeing.health/icas-zoho/v1/'

/**
 * Hook to load the ICAS chat script for web applications.
 * This hook handles the dynamic loading and cleanup of the ICAS Zoho chat script.
 * It also ensures the Zoho chat widget UI elements are hidden by default and only shown when explicitly opened.
 *
 * @param isWebApp - Boolean indicating if the app is running as a web application
 */
export function useICASChatScript(isWebApp: boolean) {
  useEffect(() => {
    let script: HTMLScriptElement | undefined
    let styleElement: HTMLStyleElement | undefined

    if (isWebApp && !window.Cypress) {
      script = document.createElement('script')
      script.src = ICAS_SCRIPT_URL
      script.async = true
      document.body.appendChild(script)

      // Add CSS to hide the Zoho chat widget elements
      // This ensures the chat widget doesn't show a persistent icon on the page
      // The widget will only be visible when explicitly opened
      styleElement = document.createElement('style')
      styleElement.setAttribute('data-icas-widget-hide', 'true')
      styleElement.textContent = `
        #zsiq_float {
          visibility: hidden;
        }
      `
      document.head.appendChild(styleElement)
    }

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script)
      }
      if (styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement)
      }
    }
  }, [isWebApp])
}
